var ScaleElem = function(options) {
    var _this = this,
        _initialScale = 1,
        _doubleClickScale = 2,
        //_zoomedClass = 'vr-mobile-body__page-img-wrap_zoomed';
        _zoomedClass = 'zoomin-one',
        _jsonData = {};

    var isDown = false,
        startingPoint = { x: null, y: null },
        initialScrollPoint = { x: 0, y: 0 },
        scale = 1,
        isDragging = false,
        doubleClickTime = 300,
        clickTimerId = null;


    function _resetState() {
        isDown = false;

        _resetStartingPoint();
        _resetInitialScrollPoint();
    }


    function _resetStartingPoint() {
        startingPoint = { x: null, y: null };
    }

    function _resetInitialScrollPoint() {
        initialScrollPoint = { x: 0, y: 0 };
    }

    function _handleMouseDown(e) {
        e.preventDefault();
        isDown = true;
        isDragging = false;

        //Init pointer click point coordinates.
        startingPoint = { x: e.clientX, y: e.clientY };
        // console.log('%cstartingPoint:', 'color: green', { x: startingPoint.x, y: startingPoint.y });
    }

    function _handleMouseUp(e) {
        e.preventDefault();

        _resetState(e);
        // console.log('mouseup', { isDown });
    }

    function _handleMouseLeave(e) {
        _resetState(e)
        // console.log('%c mouseleave', 'color: rebeccapurple');
    }

    function _isDragging(e){
        var _mouseMoveTreshold = 15;
        return Math.abs(scrollDistance.x) > _mouseMoveTreshold || Math.abs(scrollDistance.y) > _mouseMoveTreshold ;
    }

    function _handleMouseMove(e) {
        if (!isDown) {
            return;
        }

        e.preventDefault();

        var elem = $(e.target).closest('.' + options.parentClassName)[0];

        if(!$(elem).hasClass(options.parentClassName)){
            return;
        }

        scrollDistance = {
            x: startingPoint.x - e.clientX,
            y: startingPoint.y - e.clientY
        };
        
        // console.log('scrollDistance x:', scrollDistance.x, ' y:', scrollDistance.y);
        isDragging = _isDragging(scrollDistance);

        if (!initialScrollPoint.x && !initialScrollPoint.y) {
            initialScrollPoint.x = elem.scrollLeft;
            initialScrollPoint.y = elem.scrollTop;
        }

        elem.scrollLeft = scrollDistance.x + initialScrollPoint.x;
        elem.scrollTop = scrollDistance.y + initialScrollPoint.y;
    }

    function _handleClick(e) {

        if($(e.target).closest(".page_counter").length === 1) {
            var pageId = $(e.target).closest(".page_counter").attr("data-page-id");
        }
        /* Check if double click is only inside brochure pages in order not to prevent ordinary element click*/
        if($(e.target).closest('.vr-mobile-body .vr-mobile-body__page-img-wrap').length === 0 ||
            $(e.target).closest('.vr-mobile-body__page-img-wrap_app-promo-page').length === 1 ||
            $(e.target).closest('.vr-mobile-body__page-img-wrap_specific-promo-page').length === 1
            ){
            return;
        }

        /* Detect double click */
        if (clickTimerId) {
            clearTimeout(clickTimerId);
            clickTimerId = null;
            
            e.preventDefault(); //prevent single click, when double click is in action
            fireEvent(window, 'view.doubleclick', { eventData: e });
        } else {
            e.preventDefault();
            clickTimerId = setTimeout(function() {
                
                clickTimerId = null;
                _clickDispatcher(e);
            }, doubleClickTime);
        }
    }

    function _handleDoubleClick(e) {
        var eData = e.customMessage.eventData,
            scrollDistance = { x: 0, y: 0 },
            $elemParent,
            elemBoundingRect;
            
        $elemParent = $(eData.target).closest('.' + options.parentClassName);

        if($elemParent.length === 0){
            return;
        }

        elemBoundingRect = $elemParent[0].getBoundingClientRect();

        $childElem = $elemParent.find('.vr-mobile-body__page-img, .xml-slide');
        //scale = $childElem.data('scale') || _initialScale;



        /* Check if elem has already been zoomed. */
        // if (scale === _initialScale) {
        //     scale = _doubleClickScale;
        //     $elemParent.addClass(_zoomedClass);
        //     $elemParent.data('scale', scale);

        //     _loadLargeImg($elemParent);
        // } else {
        //     scale = _initialScale;
        //     $elemParent.removeClass(_zoomedClass);
        //     $elemParent.removeData('scale');
        // }

        if($elemParent.hasClass("zoomin-one") || $elemParent.hasClass("zoomin-two") || $elemParent.hasClass("zoomout-one")) {
            $elemParent.removeClass("zoomin-one zoomin-two zoomout-one");
            $(".zoomin_icon").show();
            $(".zoomout_icon").hide();
            scale = 1;
        } else {
            scale = 2;
            $elemParent.addClass(_zoomedClass);

            _loadLargeImg($elemParent);
        }

        fireEvent(window, ViewConsts.events.viewDoubleclickPinresize, { scale: scale, page: $elemParent });

        //$childElem[0].style.transform = 'scale(' + scale + ')';

        // elemBoundingRect = eData.target.getBoundingClientRect();

        //$childElem.data('scale', scale);

        /* Calculate distance between click point and left edge of element. */
        scrollDistance.x = eData.clientX - elemBoundingRect.left;
        scrollDistance.y = eData.clientY - elemBoundingRect.top;

        /* Calculate elem scroll distance after scale has changed, so that click point remains the same after zoom. */
        scrollDistance.x = (scrollDistance.x * scale) - scrollDistance.x;
        scrollDistance.y = (scrollDistance.y * scale) - scrollDistance.y;
        
        $elemParent[0].scrollLeft = Math.abs(scrollDistance.x);
        $elemParent[0].scrollTop = Math.abs(scrollDistance.y);
    }

    function _clickDispatcher(e){
        var $el = $(e.target),
            _productZoneClass = 'product-zone',
            _xmlProductEvent = 'view.xml.product.onclick';
        
        /* Prevent click if page is zoomed and being dragged. */
        if(isDragging){
            return;
        }

        if($el.hasClass(_productZoneClass) || $el.closest('.' + _productZoneClass).length > 0){
            e.preventDefault();
            $el = $el.hasClass(_productZoneClass) ? $el : $el.closest('.' + _productZoneClass);
            // console.log('firing ' + _xmlProductEvent);
            fireEvent(window, _xmlProductEvent, $el);
        }

        var _sliderPinZoneClass = 'slider-pin-zone',
            _sliderPinZoneEvent = 'view.pin.onclick';

        if($el.hasClass(_sliderPinZoneClass) || $el.closest('.' + _sliderPinZoneClass).length > 0){
            e.preventDefault();
            $el = $el.hasClass(_sliderPinZoneClass) ? $el : $el.closest('.' + _sliderPinZoneClass);

            // console.log('firing ' + _sliderPinZoneEvent);
            fireEvent(window, _sliderPinZoneEvent, $el);
        }        
    }
        
    function _loadLargeImg($page){
        var pageInx = $page.data('page-inx'),
            largeImgSrc = '';

        if(typeof gal.jsonData.originalItems[pageInx] === 'undefined' 
            || typeof gal.jsonData.originalItems[pageInx].largeImage === 'undefined'
            || $page.data('large-loaded') === true){
            return;
        }

        largeImgSrc = gal.jsonData.originalItems[pageInx].largeImage.src;

        $page.find('.vr-mobile-body__page-img').attr('src', largeImgSrc);
        $page.data('large-loaded', true);
    }
    
    function _init() {        
        var elemSel = '.vr-mobile-body .vr-mobile-body__page-img-wrap';

        $(document).on('mousedown', elemSel, _handleMouseDown);
        $(document).on('mouseup', elemSel, _handleMouseUp);
        $(document).on('mousemove', elemSel, _handleMouseMove);
        $(document).on('mouseleave', elemSel, _handleMouseLeave);
        $(document).on('click', elemSel, _handleClick);

        window.addEventListener('view.doubleclick', _handleDoubleClick);
    }

    _init();

    _this.init = _init;
};